import React, { useState } from "react";
import { RoundButton } from "components/Button";
import { ReactComponent as MedicalNoteIcon } from "assets/icons/medical-note.svg";
import { ReactComponent as UserGroupIcon } from "assets/icons/user-group.svg";
import { ReactComponent as BuildingIcon } from "assets/icons/building.svg";
import { ReactComponent as EuroIcon } from "assets/icons/euro.svg";
import { ReactComponent as CalendarIcon } from "assets/icons/calendar.svg";
import AddressesList from "./AddressesList";
import MedicalNotesList from "./MedicalNotesList";
import Bills from "./Bills";
import PatientsList from "./ClientsList";
import BookingsList from "./BookingsList";

type SelectedIcon =
  | "medicalNote"
  | "userGroup"
  | "building"
  | "euro"
  | "bookings";

const Components = {
  medicalNote: MedicalNotesList,
  userGroup: PatientsList,
  building: AddressesList,
  euro: Bills,
  bookings: BookingsList,
};

const DetailSelector = () => {
  const [selected, setSelected] = useState<SelectedIcon>("medicalNote");

  const SelectedComponent = Components[selected];

  return (
    <div className="p-4">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex flex-wrap gap-4">
          <RoundButton
            Icon={MedicalNoteIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "medicalNote"}
            onClick={() => setSelected("medicalNote")}
          />

          <RoundButton
            Icon={UserGroupIcon}
            size="large"
            selected={selected === "userGroup"}
            onClick={() => setSelected("userGroup")}
          />

          <RoundButton
            Icon={BuildingIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "building"}
            onClick={() => setSelected("building")}
          />

          <RoundButton
            Icon={EuroIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "euro"}
            onClick={() => setSelected("euro")}
          />

          <RoundButton
            Icon={CalendarIcon}
            size="large"
            selected={selected === "bookings"}
            onClick={() => setSelected("bookings")}
          />
        </div>
      </div>

      <SelectedComponent />
    </div>
  );
};

export default DetailSelector;
